/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "checkmark-indeterminate",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#377D3C"
            },
            "checkmarkIndeterminate": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "8",
            "height": "8"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 8 8", className: "checkmark-indeterminate", width: this.props.width, height: this.props.height, style: this.props.checkmarkIndeterminate },
            _react2["default"].createElement("path", { id: "XMLID_1_", className: "st0", d: "M0 0h8v8H0z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/checkmark-indeterminate.js